// CalendarMonthComponent stub (R1,R2,R10,R11) + T11 (loading & empty states)
import { DaySummary } from '../services/month-data.service';
import {
  canGoToNextMonth,
  canGoToPreviousMonth,
  formatMonthTitle,
  shiftMonth,
  type YearMonth,
} from '../utils/month-nav';

export class CalendarMonthComponent {
  days: DaySummary[] = []; // R1,R11
  year: number;
  month: number; // 1-12
  private loading = false; // T11

  constructor(year?: number, month?: number, private readonly now: () => Date = () => new Date()) {
    const d = this.now();
    this.year = year ?? d.getUTCFullYear(); // R10
    this.month = month ?? (d.getUTCMonth() + 1); // R10
  }

  view(): YearMonth {
    return { year: this.year, month: this.month };
  }

  setView(view: YearMonth): void {
    this.year = view.year;
    this.month = view.month;
  }

  setData(days: DaySummary[]) { // R1
    this.days = days;
  }

  cellCount(): number { return this.days.length; } // R1

  sentimentTriple(day: DaySummary): string { // R2
    const s = day.sentiments; return `${s.positive}:${s.neutral}:${s.negative}`; // R2
  }

  // T11: Loading state management
  isLoading(): boolean {
    return this.loading;
  }

  setLoading(value: boolean): void {
    this.loading = value;
  }

  // T11: Empty state detection (R11)
  isEmpty(): boolean {
    return this.days.length === 0;
  }

  emptyStateMessage(): string {
    return 'No data available for this month';
  }

  // T11: Accessibility helpers (R11)
  ariaBusy(): string {
    return this.loading ? 'true' : 'false';
  }

  ariaLabel(): string {
    return `Calendar for ${this.monthTitle()}`;
  }

  monthTitle(): string {
    return formatMonthTitle(this.view());
  }

  previousMonth(): YearMonth {
    return shiftMonth(this.view(), -1);
  }

  nextMonth(): YearMonth {
    return shiftMonth(this.view(), 1);
  }

  canGoPrevious(): boolean {
    return canGoToPreviousMonth(this.view());
  }

  canGoNext(): boolean {
    return canGoToNextMonth(this.view(), this.now());
  }
}
